var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMembers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.481,
    height: 30,
    viewBox: "0 0 27.481 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2851",
    transform: "translate(-247.072 -38)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_766",
    "data-name": "Groupe 766",
    transform: "translate(247.072 38)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_88",
    "data-name": "Ellipse 88",
    transform: "translate(4.34 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1764",
    "data-name": "Path 1764",
    d: "M-536.865,390.655a7.149,7.149,0,0,1-7.141-7.14,7.15,7.15,0,0,1,7.141-7.141,7.149,7.149,0,0,1,7.14,7.141A7.148,7.148,0,0,1-536.865,390.655Zm0-12.052a4.918,4.918,0,0,0-4.913,4.912,4.917,4.917,0,0,0,4.913,4.911,4.917,4.917,0,0,0,4.911-4.911A4.917,4.917,0,0,0-536.865,378.6Z",
    transform: "translate(544.006 -376.374)",
    fill: "#CD004B"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Trac\\xE9_390",
    "data-name": "Trac\\xE9 390",
    transform: "translate(0 15.065)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1765",
    "data-name": "Path 1765",
    d: "M-532.071,413.752h-14.866a4.042,4.042,0,0,1-3.346-1.772,4.049,4.049,0,0,1-.417-3.77,11.976,11.976,0,0,1,11.2-7.609,11.978,11.978,0,0,1,11.2,7.609,4.049,4.049,0,0,1-.417,3.77A4.042,4.042,0,0,1-532.071,413.752ZM-539.5,402.83a9.758,9.758,0,0,0-9.124,6.2,1.8,1.8,0,0,0,.187,1.7,1.8,1.8,0,0,0,1.5.8h14.866a1.8,1.8,0,0,0,1.5-.8,1.8,1.8,0,0,0,.187-1.7,9.759,9.759,0,0,0-9.124-6.2Z",
    transform: "translate(550.985 -400.601)",
    fill: "#CD004B"
  }))), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_213",
    "data-name": "Ellipse 213",
    cx: 6.5,
    cy: 6.5,
    r: 6.5,
    transform: "translate(261.553 55)",
    fill: "#CD004B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-plus",
    "data-name": "Icon awesome-plus",
    d: "M5.8,4.7H3.791V2.7a.446.446,0,0,0-.446-.446H2.9a.446.446,0,0,0-.446.446V4.7H.446A.446.446,0,0,0,0,5.149v.446a.446.446,0,0,0,.446.446H2.453V8.047a.446.446,0,0,0,.446.446h.446a.446.446,0,0,0,.446-.446V6.041H5.8a.446.446,0,0,0,.446-.446V5.149A.446.446,0,0,0,5.8,4.7Z",
    transform: "translate(264.931 56.128)",
    fill: "#f5f5f5"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMembers);
export default __webpack_public_path__ + "static/media/members.9a49edb26b2057249d193be3eaadbecf.svg";
export { ForwardRef as ReactComponent };